<div class="hash-compare-container" [ngClass]="{ 'equal': isEqual, 'different': !isEqual }">
  <div class="hash-row">
    <span class="label">Promoted:</span>
    <span class="hash-value">{{ processedCurrentHash || '' }}</span>
    <span *ngIf="promotedAt" class="timestamp" pTooltip="Promoted at" tooltipPosition="top">{{ promotedAt | date:'short' }}</span>
  </div>
  <div class="hash-row">
    <span class="label">Last Build:</span>
    <span class="hash-value">{{ processedLastHash || '' }}</span>
  </div>
  <div *ngIf="!isEqual && processedCurrentHash && processedLastHash" class="difference-note">
    <i class="pi pi-exclamation-triangle"></i> Out of date
  </div>
  <div *ngIf="isEqual && processedCurrentHash && processedLastHash" class="equal-note">
    <i class="pi pi-check-circle"></i> Up to date
  </div>
</div> 